import {
  Alert,
  Anchor,
  Group,
  HoverCard,
  HoverCardDropdown,
  HoverCardTarget,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { IconCreditCardOff, IconInfoCircle } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../auth/useAuthContext";
import { prefillCustomerPortalLink } from "../../utils/stripePortal";
import { useAccountBilling } from "../../utils/useAccount";
import { Can } from "../auth/Can";
import classes from "./TrialBanner.module.css";

export function TrialBanner({ navCollapsed }: { navCollapsed: boolean }) {
  const { identity } = useAuthContext();
  const { trialDaysLeft, trialDaysStatus, hasPaymentMethod } =
    useAccountBilling();
  const portalLink = prefillCustomerPortalLink({
    email: identity.email,
  });

  if (!trialDaysStatus) return null;

  const daysLeftLabel = `${trialDaysLeft} days left`;

  return (
    <Can execute="account.read.billing">
      <Alert className={classes.bannerContainer} color="yellow" p="xs" mt="lg">
        <Stack gap={4} align="center">
          <Group gap="xs" justify="center">
            <Tooltip disabled={!navCollapsed} label={daysLeftLabel}>
              <Text
                size="sm"
                className={classes.bannerText}
                fw="bold"
                ta="center"
              >
                TRIAL
              </Text>
            </Tooltip>
            {!navCollapsed && (
              <Group gap={4}>
                <Can execute="account.update.billing">
                  <HoverCard width={350}>
                    <HoverCardTarget>
                      <ThemeIcon
                        variant="subtle"
                        size="sm"
                        className={classes.icon}
                      >
                        <IconInfoCircle />
                      </ThemeIcon>
                    </HoverCardTarget>
                    <HoverCardDropdown>
                      <Stack>
                        <Text size="sm">
                          Enjoying your trial?{" "}
                          <Anchor
                            component={Link}
                            to={`/account/project/team`}
                            c="yellow"
                          >
                            Invite your team
                          </Anchor>{" "}
                          to try it too.
                        </Text>
                      </Stack>
                    </HoverCardDropdown>
                  </HoverCard>
                </Can>
                {!hasPaymentMethod && (
                  <HoverCard width={350}>
                    <HoverCardTarget>
                      <ThemeIcon
                        variant="subtle"
                        size="sm"
                        className={classes.icon}
                      >
                        <IconCreditCardOff />
                      </ThemeIcon>
                    </HoverCardTarget>
                    <HoverCardDropdown>
                      <Stack>
                        <Text size="sm">
                          No payment method added. After your trial ends, access
                          will be paused until you add one.{" "}
                          <Anchor
                            href={portalLink}
                            target="_blank"
                            referrerPolicy="no-referrer"
                            c="yellow"
                          >
                            Add payment method
                          </Anchor>{" "}
                          today.
                        </Text>
                      </Stack>
                    </HoverCardDropdown>
                  </HoverCard>
                )}
              </Group>
            )}
          </Group>
          {!navCollapsed && (
            <Text size="sm" className={classes.bannerText}>
              {daysLeftLabel}
            </Text>
          )}
        </Stack>
      </Alert>
    </Can>
  );
}
